// AdSense placeholder. Replace data-ad-client + data-ad-slot with real values
// once your AdSense application is approved. The <ins class="adsbygoogle"> tag
// is required for AdSense to detect ad placements during site review.
import { useEffect } from "react";

const AD_CLIENT = "ca-pub-XXXXXXXXXXXXXXXX"; // TODO: replace with your AdSense publisher ID

export const AdSlot = ({ slot = "default", height = 100, className = "", testId, format = "auto" }) => {
    useEffect(() => {
        // Push to AdSense queue if the script is loaded. Safe no-op in dev.
        try {
            if (typeof window !== "undefined" && window.adsbygoogle) {
                window.adsbygoogle.push({});
            }
        } catch (e) {
            // Ignored — script not yet loaded or development environment
        }
    }, [slot]);

    return (
        <div
            data-testid={testId || `ad-slot-${slot}`}
            className={`relative w-full bg-muted/40 border-2 border-dashed border-foreground/20 flex items-center justify-center my-8 ${className}`}
            style={{ minHeight: height }}
        >
            <span className="absolute top-2 left-2 text-[10px] font-mono uppercase tracking-widest text-foreground/40 z-10">
                Advertisement
            </span>
            <ins
                className="adsbygoogle"
                style={{ display: "block", width: "100%", minHeight: height }}
                data-ad-client={AD_CLIENT}
                data-ad-slot={slot}
                data-ad-format={format}
                data-full-width-responsive="true"
            />
            <span className="text-foreground/30 text-sm font-mono uppercase tracking-widest pointer-events-none">
                Ad slot · {slot}
            </span>
        </div>
    );
};
